<div>

  <div class="row">
    <div class="col-md-8">
      <!--Row 1 Start-->
      <div class="row">
        <div class="col"><span><strong>Claim Type:</strong></span><span class="requiredField">*</span></div>
        <div class="col"><span>{{claim.claimTypeName}}</span></div>
        <div class="col"><span><strong>Scheduled Ship Date:</strong></span> </div>
        <div class="col"> <span>{{claim.scheduleDate | date:'MM/dd/yy'}}</span></div>
      </div>
      <!--Row 1 End-->
      <!--Row 2 Start-->
      <div class="row">
        <div class="col"><span><strong>Job Name:</strong></span></div>
        <div class="col"><span>{{claim.jobName}}</span></div>
        <div class="col"><span><strong>Shipped From:</strong></span> </div>
        <div class="col"><span>{{claim.shipFrom}}</span></div>
      </div>
      <!--Row 2 End-->
      <!--Row 3 Start-->
      <div class="row">
        <div class="col"><span><strong>Sales Order #:</strong></span></div>
        <div class="col"><span>{{claim.soNumber}}</span></div>
        <div class="col"><span><strong>Shipped To:</strong></span></div>
        <div class="col"><span>{{claim.shipTo}}</span></div>
      </div>
      <!--Row 3 End-->
      <!--Row 4 Start-->
      <div class="row">
        <div class="col"><span><strong>Customer Name:</strong></span></div>
        <div class="col"><span>{{claim.customerNumber}} - {{claim.customerName}}</span></div>
        <div class="col"><span><strong>Status:</strong></span></div>
        <div class="col"><span>{{claim.statusName}}</span></div>
      </div>
      <!--Row 4 End-->
      <!--Row 5 Start-->
      <div class="row">
        <div class="col"><span><strong>Request Type:</strong></span></div>
        <div class="col"><span>{{claim.requestTypeName}}</span></div>
        <div class="col"></div>
        <div class="col"></div>
      </div>
      <!--Row 5 End-->
    </div>
    <hr />
    <div class="col">
      <div class="row">
        <div class="col-md-3">
          <span><strong>Comments:</strong></span>
        </div>
        <!--</div>
        <div class="row">-->
        <div class="col-md-9">
          <span>{{claim.commentByUser}}</span>
        </div>
      </div>
    </div>
  </div>
</div>
<hr />
<div class="row">
  <div class="col-md-8">
    <div class="row">
      <div class="col"><span><strong>Project Manager:</strong></span></div>
      <div class="col"><span>{{claim.projectManagerJDEName}}</span></div>
      <div class="col">
        <strong>Project Manager Email:</strong>
      </div>
      <div class="col">
        {{claim.projectManagerEmail}}
      </div>
    </div>
    <div class="row">
      <div class="col"><span><strong>Sales Rep:</strong></span></div>
      <div class="col"><span>{{claim.salesRepJDEName}}</span></div>
      <div class="col">
        <strong>Sales Rep Email:</strong>
      </div>
      <div class="col">
        {{claim.salesRepEmail}}
      </div>
    </div>
    <div class="row">
      <div class="col"><span><strong>Freight Cost:</strong></span></div>
      <div class="col"><span>{{claim.freightCost| currency}}</span></div>
      <div class="col"><span><strong>Freight Price:</strong></span></div>
      <div class="col">{{claim.freightPrice| currency}}</div>
    </div>
  </div>
  <div class="col-md-4 remove-left-padding remove-right-padding">
    <div class="row">
      <div class="col-md-4">
        <span><strong>Internal Notes/Comments:</strong></span>
      </div>
      <!--</div>
      <div class="row">-->
      <div class="col-md-8  remove-left-padding remove-right-padding">
        <kendo-textarea placeholder="Notes only visible to ineternal admin, to print on final distribution (on complete)"
                        col="300"
                        style="width:100%; margin-bottom:5px;"
                        [(ngModel)]="internalNotes"
                        rows="4"></kendo-textarea>
      </div>
    </div>
  </div>
</div>
<div>
  <kendo-grid [data]="trackShipmentTabGridData"
              class="orderInquiryDetailsGridCls"
              [sortable]="true"
              [selectable]="false"
              [navigable]="true"
              [filterable]="true"
              [groupable]="false"
              [reorderable]="true"
              [resizable]="true"
              [sort]="trackShipmentGridstate.sort"
              [pageable]="{ buttonCount: 5, info: true, pageSizes:[50,75,100] }"
              [pageSize]="trackShipmentGridstate.take"
              [skip]="trackShipmentGridstate.skip"
              [columnMenu]="{ filter: false, sort: false }"
              (sort)="trackShipmentGridSortChange($event)"
              (pageChange)="trackShipmentGridPageChange($event)"
              (dataStateChange)="trackShipmentDataStateChange($event)"
              (columnReorder)="onShipmentReorder($event)"
              (columnVisibilityChange)="onShipmentVisibilityChange($event)"
              [filter]="trackShipmentGridstate.filter"
              [loading]="claimItemGridLoading">
    <ng-template kendoGridToolbarTemplate>
      <!--<div class="k-grid-toolbar-button-display hideToolBarBtnInPwa">
        <button kendoButton class="excel-button" icon="file-excel" [disabled]="loadingExcel" (click)="generateShipmentExcel()">
          {{orderDetailTxt.exportToExcelLbl?orderDetailTxt.exportToExcelLbl:orderDetail.exportToExcelLbl}}
          <kendo-loader *ngIf="loadingExcel"></kendo-loader>
        </button>
        <button kendoButton icon="file-pdf" class="pdf-button" [disabled]="loadingPDF" (click)="generateShipmentPDF()">

          {{orderDetailTxt.exportToPdfLbl?orderDetailTxt.exportToPdfLbl:orderDetail.exportToPdfLbl}}
          <kendo-loader *ngIf="loadingPDF"></kendo-loader>
        </button>
      </div>-->
      <!--<input placeholder="Search in all columns..."
           kendoTextBox
           (input)="onFilterTrackShipment($event.target.value)" class="pwaOrderInquiryDetailsSearch" />-->
    </ng-template>

    <!--<kendo-grid-column media="(max-width: 1024px)" title="Track Shipment">
      <ng-template kendoGridCellTemplate let-dataItem>

        <div class="row mb-2">
          <div class="col-12 descriptionPwa">
            {{dataItem.shipmentId}}- {{dataItem.carrier}}
          </div>
        </div>

        <div class="row">
          <div class="col-sm-4 col-md-4 paddingZero">
            <span class="txt-bold descriptionPwa">{{orderDetailTxt.proNoLbl ? orderDetailTxt.proNoLbl : orderDetail.proNoLbl}}:</span> <span class="float-right-pwa"> {{dataItem.proNo}}</span>
          </div>
          <div class="col-sm-4 col-md-4 paddingZero">
            <span class="txt-bold"> {{orderDetailTxt.noOfBoxesLbl ? orderDetailTxt.noOfBoxesLbl : orderDetail.noOfBoxesLbl}}:</span> <span class="float-right-pwa"> {{dataItem.noOfBoxes}}</span>
          </div>
          <div class="col-sm-4 col-md-4 paddingZero">
            <span class="txt-bold"> {{orderDetailTxt.totalWeightLbl ? orderDetailTxt.totalWeightLbl : orderDetail.totalWeightLbl}}:</span> <span class="float-right-pwa"> {{dataItem.totalWeight}}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-4 col-md-4 paddingZero">
            <span class="txt-bold descriptionPwa">{{orderDetailTxt.billOfLading ? orderDetailTxt.billOfLading : orderDetail.billOfLading}}:</span> <span class="float-right-pwa"> {{dataItem.billOfLoading}}</span>
          </div>
          <div class="col-sm-4 col-md-4 paddingZero">
            <span class="txt-bold">{{orderDetailTxt.shipDateLbl ? orderDetailTxt.shipDateLbl : orderDetail.shipDateLbl}}:</span> <span class="float-right-pwa"> {{dataItem.shipDateUIString | date:'M/dd/yyyy'}}</span>
          </div>
          <div class="col-sm-4 col-md-4 paddingZero"></div>
        </div>

      </ng-template>
    </kendo-grid-column>-->
    <kendo-grid-column *ngFor="let col of gridShipmentSettings.columnsConfig"
                       [field]="col.field"
                       [title]="col.title"
                       [width]="col._width"
                       [filter]="col.filter"
                       [filterable]="col.filterable"
                       [hidden]="col.hidden"
                       [format]="col.format" media="(min-width: 1025px)">
      <!--<ng-template *ngIf="col.field=='shipDate'" kendoGridFooterTemplate>
        <div>
          <div>
            <strong>Total: {{toatlApprovedAmt | currency}}</strong>
          </div>
        </div>
      </ng-template>-->
    </kendo-grid-column>
    <ng-template kendoGridNoRecordsTemplate>
    </ng-template>


    <ng-template kendoGridDetailTemplate let-dataItem>
      <kendo-grid [data]="dataItem.items">
        <!--<kendo-grid-column media="(max-width: 1024px)">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="row">
              <div class="col-sm-4 col-md-4 paddingZero">
                <span class="txt-bold descriptionPwa">Shipment ID:</span> <span class="float-right-pwa"> {{dataItem.shipmentid}}</span>
              </div>
              <div class="col-sm-4 col-md-4 paddingZero">
                <span class="txt-bold descriptionPwa">Box No:</span> <span class="float-right-pwa"> {{dataItem.boxno}}</span>
              </div>
              <div class="col-sm-4 col-md-4 paddingZero">
                <span class="txt-bold descriptionPwa">Item:</span> <span class="float-right-pwa"> {{dataItem.item}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-8 col-md-8 paddingZero">
                <span class="txt-bold descriptionPwa">Item Description:</span> <span class="float-right-pwa"> {{dataItem.itemdescription}}</span>
              </div>
              <div class="col-sm-4 col-md-4 paddingZero">
                <span class="txt-bold descriptionPwa">Quantity:</span> <span class="float-right-pwa"> {{dataItem.quantity}}</span>
              </div>

            </div>
          </ng-template>
        </kendo-grid-column>-->
        <kendo-grid-column field="shipmentId" title="Shipment ID" media="(min-width: 1025px)"
                           [width]="90"
                           [headerStyle]="{'font-size':'10px'}">
        </kendo-grid-column>
        <kendo-grid-column field="boxno" [headerStyle]="{'font-size':'10px'}" [width]="75" title="Box No" media="(min-width: 1025px)">
        </kendo-grid-column>
        <kendo-grid-column field="itemNumber" [headerStyle]="{'font-size':'10px'}" title="Item" media="(min-width: 1025px)">
        </kendo-grid-column>
        <kendo-grid-column field="itemDescription" [headerStyle]="{'font-size':'10px'}" title="Item Description" media="(min-width: 1025px)">
        </kendo-grid-column>
        <kendo-grid-column field="itemWeight" [headerStyle]="{'font-size':'10px'}" [width]="75" title="Item Weight" media="(min-width: 1025px)">
          <ng-template kendoGridCellTemplate
                       let-filter
                       let-column="column"
                       let-dataItem
                       media="(min-width: 1025px)">
            <div *ngIf="dataItem.itemWeight && dataItem.itemWeight>0">
              {{dataItem.itemWeight}}
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="originalQuantity" [headerStyle]="{'font-size':'10px'}" [width]="75" title="Box Quantity" media="(min-width: 1025px)">
        </kendo-grid-column>
        <kendo-grid-column field="claimedQuantity" [headerStyle]="{'font-size':'10px'}" title="Quantity Claimed" media="(min-width: 1025px)">
        </kendo-grid-column>
        <kendo-grid-column field="approvedQuantity" [headerStyle]="{'font-size':'10px'}" title="Quantity Approved" media="(min-width: 1025px)">
          <ng-template kendoGridCellTemplate
                       let-filter
                       let-column="column"
                       let-dataItem
                       media="(min-width: 1025px)">
            <div *ngIf="claim.statusId==1 || claim.statusId==4">
              <kendo-numerictextbox [spinners]="false" [decimals]="0"
                                    [format]="'n0'"
                                    [step]="1"
                                    [style.width.px]="50"
                                    [max]="dataItem.claimedQuantity"
                                    [autoCorrect]="true"
                                    (valueChange)="handleClaimQuantityChange($event,dataItem)"
                                    [value]="dataItem.approvedQuantity"
                                    [min]="0">
              </kendo-numerictextbox>
            </div>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="unitPrice" [headerStyle]="{'font-size':'10px'}" title="Unit Price" media="(min-width: 1025px)">
          <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem>
            {{dataItem?.unitPrice |currency}}
          </ng-template>
        </kendo-grid-column>
        <!--<kendo-grid-column field="extendedPrice" [headerStyle]="{'font-size':'10px'}" title="Extended Price" media="(min-width: 1025px)">
          <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem>
            {{dataItem?.extendedPrice |currency}}
          </ng-template>
        </kendo-grid-column>-->
        <!--<kendo-grid-column field="approvedPrice" title="Total Approved Price" media="(min-width: 1025px)">
        </kendo-grid-column>-->
        <!--<kendo-grid-column field="unitCost" [headerStyle]="{'font-size':'10px'}" title="Unit Cost" media="(min-width: 1025px)">
          <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem>
            {{dataItem?.unitCost |currency}}
          </ng-template>
        </kendo-grid-column>-->
        <!--<kendo-grid-column field="extendedCost" [headerStyle]="{'font-size':'10px'}" title="Extended Cost" media="(min-width: 1025px)">
          <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem>
            {{dataItem?.extendedCost |currency}}
          </ng-template>
        </kendo-grid-column>-->
        <kendo-grid-column field="claimedValue" [headerStyle]="{'font-size':'10px'}" title="Claimed Value" media="(min-width: 1025px)">
          <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem>
            {{dataItem?.claimedValue  |currency}}
          </ng-template>
          <ng-template kendoGridFooterTemplate>
            {{dataItem?.totalClaimedValue  |currency}}
          </ng-template>
        </kendo-grid-column>


        <kendo-grid-column field="approvedValue" [headerStyle]="{'font-size':'10px'}" title="Approved Value" media="(min-width: 1025px)">
          <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem>
            {{dataItem?.approvedValue |currency}}
          </ng-template>
          <ng-template kendoGridFooterTemplate>
            {{dataItem?.totalApprovedValue  |currency}}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="approvedWeight" [headerStyle]="{'font-size':'10px'}" title="Approved Weight" media="(min-width: 1025px)">
          <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem>
            {{dataItem.approvedWeight | number : '1.0-4'}}
          </ng-template>
          <ng-template kendoGridFooterTemplate>
            {{dataItem?.totalApprovedWeight | number : '1.0-4'}}
          </ng-template>
        </kendo-grid-column>


      </kendo-grid>
    </ng-template>
    <!--<ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
    </ng-template>-->
  </kendo-grid>
</div>
<br />
<div class="row">
  <div class="col-md-4">
    <fieldset>
      <legend style="width:auto; margin-bottom: 0px; font-weight: bold; color: #1f497d;"></legend>
      <span><b>Bill of Lading notating damage at time of delivery<br /> (claims will be denied if this is not provided)</b></span><br />
      <ul *ngFor="let item of claim.carrierInspectionReports">
        <li><a href="javascript:void(0)" (click)="openDocument(item.fullPath)">{{item.fileName}}</a></li>
      </ul>
    </fieldset>
    <br />
    <fieldset>
      <legend style="width:auto; margin-bottom: 0px; font-weight: bold; color: #1f497d;"></legend>
      <span><b>Photos of damage with material in its original Packaging</b></span><br />
      <ul *ngFor="let item of claim.damagedMaterialPhotos">
        <li><a href="javascript:void(0)" (click)="openDocument(item.fullPath)">{{item.fileName}}</a></li>
      </ul>
    </fieldset>
  </div>
  <div class="col-md-8 remove-left-padding remove-right-padding">
    <div class="row">
      <div class="col-md-4" style="text-align:right;"><span><strong>Comments/Notes to Customer(COMPLETE):</strong></span></div>
      <div class="col-md-8 remove-left-padding remove-right-padding">
        <kendo-textarea placeholder="Notes visible to customer in Claim History screen, to print on final distribution (on complete)"
                        col="300"
                        style="width:100%"
                        (valueChange)="onCustomerCommentChange($event)"
                        [ngClass]="{warningErrorBorder : (isCompleteClicked || isDeclineClicked) && !isCommentToUserEntered }"
                        [(ngModel)]="commentToUser"
                        rows="4"></kendo-textarea>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4"></div>
      <div class="col-md-8 remove-left-padding remove-right-padding">
        <div class="flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row">
          <button kendoButton
                  (click)="declineTransferToQualityClaim()" style="margin-top: 5px;">
            DECLINE-TRANSFER TO QUALITY CLAIM
          </button>
          <div class="flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row" style="float:right;">
            <button kendoButton
                    (click)="holdClaim()"
                    class="clearKendoButton btn btn-success" style="margin-top: 5px;margin-right:10px;">
              SAVE/HOLD
            </button>
            <button kendoButton
                    (click)="completeClaim()"
                    class="clearKendoButton btn btn-success" style="margin-top: 5px;">
              COMPLETE
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4"></div>
      <div class="col-md-8 remove-left-padding remove-right-padding" style="margin-top:5px;">
        <div class="flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row">
          <span>Quality Email: </span>
          <input kendoTextBox
                 (blur)="onQualityEmailFieldChange($event)"
                 (valueChange)="onQualityEmailFieldChange($event)"
                 [ngClass]="{warningErrorBorder : (isDeclineClicked) && !isQualityEmailValid }"
                 [(ngModel)]="qualityDeptEmail" />

          <div class="flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row" style="float:right;">
            <span>CC Email: </span>
            <input kendoTextBox
                   [(ngModel)]="ccEmail" />
          </div>
        </div>
              </div>
      </div>
  </div>
</div>

<section>
  <kendo-dialog *ngIf="showConf"
                title="Freight Claim Processing"
                (close)="closeConfirmDialog()">
    <div style="text-align: center;">
      <span class="k-icon k-i-check-outline k-i-checkmark-outline k-i-success"
            style="font-size:50px;color:green"></span>
      <p>Claim Details updated Successfully</p>
      <p>
        <button kendoButton primary="true" style="width: 150px;" [routerLink]="['/review-open-claims']">Open Claims</button>&nbsp;&nbsp;
        <button kendoButton primary="true" style="width: 150px;" [routerLink]="['/view-claim-history']">Claims History</button>
      </p>
    </div>
  </kendo-dialog>
</section>




